import React, { PureComponent } from 'react';
import errorBoundary from '@ifeng-fe/errorBoundary';
import PropTypes from 'prop-types';
import { h5PageCount } from 'ThreeTerminal_utils';
import { QQShare } from 'ThreeTerminal_mobile_dynamic';
import { getPhtvSoleNewsList } from '../../../services/api';
import Header from './header';
import VideoArea from './videoArea';
import FeedTabList from './feedTabList';
import BottomSlide from './bottomSlide';
import styles from './index.css';

class Layout extends PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    state = {
        bannerImg: '',
        pageTitle: '',
        yearList: [],
        currentYear: new Date().getFullYear(),
        liveFeedData: [],
        columnId: '',
        dataLoadFail: false,
    };

    async componentDidMount() {
        const {
            content: { cid = '' },
        } = this.props;

        try {
            const columnId = cid; // 8273
            const year = this.getUrlParams(location.href).year || new Date().getFullYear();
            const page = 1;
            const result = await getPhtvSoleNewsList(columnId, year, page);
            const bannerImg = (result.chConfig && result.chConfig.backgroundImg) || '';
            const pageTitle = (result.chConfig && result.chConfig.chname) || '';
            const pageBref = (result.chConfig && result.chConfig.intro) || '';
            const yearList = (result.chConfig && result.chConfig.schedule && result.chConfig.schedule.year) || [];
            const currentYear = result.chConfig && result.chConfig.schedule && result.chConfig.schedule.currentYear;
            const liveFeedData = result.list || [];

            if (liveFeedData.length === 0) {
                this.setState({
                    dataLoadFail: true,
                });
            }

            h5PageCount([
                {
                    behavior: 'page',
                    type: 'phtv',
                    other: {
                        id: `phtvsole_${columnId}`,
                        url: encodeURIComponent(location.href),
                    },
                },
            ]);
            this.setState({
                bannerImg,
                pageTitle,
                pageBref,
                yearList,
                currentYear,
                liveFeedData,
                columnId,
            });
        } catch (e) {
            this.setState({
                dataLoadFail: true,
            });
        }
    }

    getUrlParams = (url) => {
        const result = {};
        const search = url.split('?')[1] || '';
        const params = search.split('&');
        let param = [];

        for (let i = 0, iLen = params.length; i < iLen; i++) {
            param = params[i].split('=');
            if (param.length === 2) {
                result[param[0]] = decodeURIComponent(param[1]);
            }
        }

        return result;
    };

    setCurrentYear = (year) => {
        this.setState({
            currentYear: year,
        });
    };

    render() {
        const {
            content: {
                url = '',
                _id = '',
                guid = '',
                base62Id = '',
                headKeyword = [],
                unfoldType,
                videoPlayUrl,
                videoInfo,
            },
        } = this.props;
        const { bannerImg, pageTitle, pageBref, yearList, currentYear, liveFeedData, columnId, dataLoadFail } =
            this.state;
        const wxLaunchVal = (unfoldType && unfoldType.wxLaunch) || {};
        const wxLaunchConfig = {
            wxLaunchType: wxLaunchVal.wxLaunchType === '1' ? 'app' : 'weapp',
            wxLaunchSwitch: wxLaunchVal.wxLaunchSwitch === '1',
        };
        const headData = {
            url,
            _id,
            guid,
            currentYear,
            base62Id,
            headKeyword,
            wxLaunch: wxLaunchConfig,
            columnId,
        };
        const videoData = {
            base62Id,
            columnId,
            currentYear,
            videoPlayUrl,
            bannerImg,
            pageTitle,
            pageBref,
            videoInfo,
        };
        const yearData = {
            yearList,
            currentYear,
            liveFeedData,
            columnId,
            base62Id,
        };
        const bottomSlideData = {
            base62Id,
            guid,
            wxLaunchConfig,
        };
        const qqShareCofig = {
            title: videoInfo.title || pageTitle,
            img:
                videoInfo.sharePosterUrl ||
                bannerImg ||
                'https://p1.ifengimg.com/29b92e35b2b20708/2017/51/ifengLogo300x300.jpg',
            desc: '',
            cb: () => {},
        };

        return (
            <div className={styles.pageBody}>
                <Header content={headData} />
                <VideoArea content={videoData} />
                {liveFeedData.length > 0 && <FeedTabList content={yearData} setCurrentYear={this.setCurrentYear} />}
                {dataLoadFail && (
                    <div
                        className={styles.dataLoadFail}
                        onClick={() => {
                            location.reload();
                        }}
                    />
                )}
                <BottomSlide content={bottomSlideData} />
                {qqShareCofig.title && <QQShare content={qqShareCofig} />}
            </div>
        );
    }
}

export default errorBoundary(Layout);
